import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {ChainsService} from './chains.service';
import {Chain} from './chains.model';

@Injectable({
  providedIn: 'root'
})
export class ChainsResolver{
  private chainsService = inject(ChainsService);

  getChains(): Observable<Chain[]> {
    return this.chainsService.getAllChains();
  }
}

export const chainsResolver: ResolveFn<Chain[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(ChainsResolver).getChains();
  };
